import { ALLOWED_LABEL_LAYOUTS, sanitizeAllowedString, sanitizeBindable, sanitizeBoolean, sanitizeBoundValue, sanitizeString } from './helpers';
export function sanitizeTextarea(el) {
  const value = sanitizeBoundValue(el.value);
  if (!value) return null;
  return {
    type: 'Textarea',
    value,
    label: sanitizeBindable(el.label, sanitizeString),
    labelLayout: sanitizeBindable(el.labelLayout, v => sanitizeAllowedString(v, ALLOWED_LABEL_LAYOUTS)),
    placeholder: sanitizeBindable(el.placeholder, sanitizeString),
    required: sanitizeBindable(el.required, sanitizeBoolean),
    disabled: sanitizeBindable(el.disabled, sanitizeBoolean)
  };
}